import styled from 'styled-components';
import { media } from '../../../../helpers/breakpoints';
import {
  GoogleReviewContainer,
  GoogleReviewsLink,
  Review,
  ReviewSummary,
} from '../../../../components/PageWrappers/AdDetails/components/GoogleReviews/GoogleReviewPanel/GoogleReviewPanel';
import { Wrapper } from '../../../../components/AdForm/components/Panel/Panel';

export const Main = styled.div`
  display: grid;
  padding-top: ${({ theme }) => theme.spacing.M24};

  ${media.large} {
    grid-template-columns: 1fr 720px 1fr;
    grid-gap: ${({ theme }) => theme.spacing.L40};
  }
`;

export const ReviewWrapper = styled.div`
  grid-column: 2;
  margin-bottom: ${({ theme }) => theme.spacing.M24};
  ${GoogleReviewContainer} {
    padding: 0;
  }
  ${Wrapper} {
    padding: 0;
  }
  ${ReviewSummary} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};
    padding: ${({ theme }) => theme.spacing.M16};
    margin-bottom: ${({ theme }) => theme.spacing.M16};
    ${media.medium} {
      padding: ${({ theme }) => theme.spacing.M24};
      margin-bottom: ${({ theme }) => theme.spacing.M24};
    }
  }
  ${Review} {
    padding: 0 ${({ theme }) => theme.spacing.M16};
    margin: 0;
    margin-bottom: ${({ theme }) => theme.spacing.M16};
    ${media.medium} {
      padding: 0 ${({ theme }) => theme.spacing.M24};
      margin-bottom: ${({ theme }) => theme.spacing.M24};
    }
  }
  ${GoogleReviewsLink} {
    color: ${({ theme }) => theme.colors.BLUE};
    padding: 0 ${({ theme }) => theme.spacing.M16}
      ${({ theme }) => theme.spacing.M16} ${({ theme }) => theme.spacing.M16};
    ${media.medium} {
      padding: 0 ${({ theme }) => theme.spacing.M24}
        ${({ theme }) => theme.spacing.M24} ${({ theme }) => theme.spacing.M24};
    }
    a {
      color: ${({ theme }) => theme.colors.BLUE};
    }
  }
`;
